import { defineStore } from 'pinia';

// Pinia replacement for the singleton scalars that lived in Vuex root state.
// These are app-wide settings — the user's selected location, the single
// (only) location id when the tenant has just one, the fulfillment location
// ids relevant to web orders, and the RSA public key used by the data
// exchange / buyers guide flows for FTP-password encryption.
//
// Getter and action names match the old Vuex shape (`getXxx` / `updateXxx`)
// so call sites are mostly s/this.$store.getters/useAppStateStore()/ swaps.
export const useAppStateStore = defineStore('appState', {
    state: () => ({
        selectedLocationId: null,
        singleLocationId: null,
        webOrderFulfillmentLocationIds: [],
        publicKey: null
    }),
    getters: {
        getSelectedLocationId: state => state.selectedLocationId,
        getSingleLocationId: state => state.singleLocationId,
        getWebOrderFulfillmentLocationIds: state => state.webOrderFulfillmentLocationIds,
        getPublicKey: state => state.publicKey
    },
    actions: {
        updateSelectedLocationId(value) {
            this.selectedLocationId = value;
        },
        updateSingleLocationId(value) {
            this.singleLocationId = value;
        },
        updateWebOrderFulfillmentLocationIds(value) {
            this.webOrderFulfillmentLocationIds = value;
        },
        updatePublicKey(value) {
            this.publicKey = value;
        }
    }
});
